import { clsx } from 'clsx';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { IKycDocument } from '@/features/kyc/store/models/kyc.model';

import { openModal } from '@/store/actions/core.actions';

import { useKycDocuments } from '@/features/kyc/hooks/useKycDocuments';
import { IKycDocumentReviewModalProps } from '@/features/kyc/store/types/kyc-need-review.types';

interface IKycActionsProps {
  document: IKycDocument;
}

export const KycNeedReviewActions = (props: IKycActionsProps) => {
  const { document } = props;
  const dispatch = useAppDispatch();
  const { documentTranslation } = useKycDocuments();

  const toggleModalPreviewKycDocument = () => {
    dispatch(
      openModal<IKycDocumentReviewModalProps>(
        'kycDocumentReviewModal',
        { document, isFromNeedReview: true },
        { maxWidth: 'xl' },
      ),
    );
  };

  return (
    <div
      className={clsx(
        'w-fit rounded-400 px-4 py-2 transition-colors text-onColor cursor-pointer hover:bg-opacity-75',
        document.status === 'PENDING' ? 'bg-support-warning' : 'bg-support-error',
      )}
      onClick={toggleModalPreviewKycDocument}
    >
      {documentTranslation(document.documentType)}
    </div>
  );
};
